<template>
    <div>
        <div class="pa-3">
            <v-card class="pt-2 px-3">
                <v-layout class="mx-3 mt-0" row>
                    <div
                        style=""
                        class="pt-3 text-xs-center font-weight-medium title"
                    >
                        File Downloads ({{ all.length }})
                    </div>
                    <v-checkbox
                        @change="loadFileDownloads"
                        v-model="onlyCurrentUser"
                        color="success"
                        :label="'Only for ' + user"
                        class="ml-3 mb-2"
                        hide-details
                    ></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="fileDownloadsToDisplay.length"
                        class="mx-1"
                        @click="loadFileDownloads"
                        small
                        color="success"
                        style="height: 28px;"
                        >Refresh</v-btn
                    >
                </v-layout>

                <!-- <v-checkbox
                    @change="loadFileDownloads"
                    v-model="onlyCurrentUser"
                    color="success"
                    :label="'Only for ' + user"
                    class="ml-3 mb-3 mt-2"
                    hide-details
                ></v-checkbox> -->
                <div style="height: 800px; overflow-y: auto;" class="mx-3 mb-3">
                    <v-layout
                        row
                        class="pa-3 mb-2"
                        justify-space-between
                        v-for="(file, index) in fileDownloadsToDisplay"
                        @click="downloadFile(file)"
                        style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                    >
                        <v-icon
                            class="width-50"
                            dark
                            :color="getStatusIconColor(file)"
                            >{{ getStatusIcon(file) }}</v-icon
                        >
                        <div class=" pl-3 font-weight-regular width-250">
                            {{ file.date | time }}
                        </div>
                        <div class=" font-weight-regular width-250">
                            {{ getFileType(file.type) }}
                        </div>
                        <div class=" font-weight-regular width-250">
                            {{ file.user }}
                        </div>
                        <div class="font-weight-regular width-250">
                            {{ file.status }}
                        </div>
                        <div
                            class=" width-350 mr-4"
                            @click.stop=""
                            v-if="file.fileURL"
                        >
                            <a
                                :href="file.fileURL"
                                target="_blank"
                                class="website-link-text"
                                >{{ getFileName(decodeURI(file.fileURL)) }}</a
                            >
                        </div>
                        <div class="width-200 mr-4" @v-if="!file.fileURL">
                            {{ file.downloadStatus }}
                        </div>
                        <v-btn
                            :loading="file.id == fileProcessing"
                            v-if="file.status != 'Completed'"
                            class="my-0 mr-4"
                            small
                            color="success"
                            @click.stop="processDownload(file)"
                            >Process Download</v-btn
                        >
                    </v-layout>
                    <v-layout justify-center>
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="7"
                            v-on:input="setPagianation"
                        ></v-pagination>
                    </v-layout>
                </div>
            </v-card>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    data() {
        return {
            fileDownloadsToDisplay: [],
            loading: false,
            onlyCurrentUser: true,
            user: "",

            deleting: false,
            uploading: false,
            fileProcessing: "",

            pagination: {
                totalCount: 0,
                rowsPerPage: 11,
                page: 1,
            },

            all: [],
        };
    },
    async created() {
        this.user = this.$store.state.authentication.user;

        this.loadFileDownloads();
    },
    watch: {},
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(this.all.length / this.pagination.rowsPerPage)
                : 0;
        },
    },
    methods: {
        async loadFileDownloads() {
            this.loading = true;

            const fileDownloads = await this.$http.get(
                "api/fileDownloads/get?user=" +
                    (this.onlyCurrentUser ? this.user : "")
            );

            this.all = fileDownloads.map((file) => {
                file.downloadStatus = file.fileURL
                    ? ""
                    : (file.downloadProgress ? file.downloadProgress : 0) +
                      "/" +
                      file.totalCount;

                return file;
            });

            this.fileDownloadsToDisplay = this.all.slice(0, 11);

            this.loading = false;
            this.pagination.page = 1;
        },
        getFileType(type) {
            return type.replace("_", " ");
        },
        getFileName(url) {
            if (!url || url == "null") return;

            return url.split("/").pop();
        },
        downloadFile(file) {
            if (!file.fileURL) return;

            window.open(file.fileURL);
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.fileDownloadsToDisplay = this.all.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        getStatusIcon(file) {
            switch (file.status) {
                case "Completed":
                    return "mdi-check-circle";
                case "Processing":
                case "Pending":
                    return "mdi-clock";
                case "Error":
                    return "mdi-alert-circle";
                default:
                    return "";
            }
        },
        getStatusIconColor(file) {
            switch (file.status) {
                case "Completed":
                    return "success";
                case "Processing":
                case "Pending":
                    return "#fdb400";
                case "Error":
                    return "#f35123";
                default:
                    return "";
            }
        },
        async processDownload(file) {
            try {
                this.fileProcessing = file.id;

                await this.$http.post(
                    "api/fileDownloads/ProcessFileDownload?id=" + file.id
                );

                this.fileProcessing = "";
                this.loadFileDownloads();

                this.$notify({
                    text: "Download Completed",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.fileProcessing = "";
            }
        },
    },
};
</script>
<style>
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
</style>
